import { CarRental, Handshake } from '@mui/icons-material';
import { IRoute } from '../interfaces';
import Cars from '../pages/Cars/Cars';
import Deal from '../pages/Deal/Deal';
import Deals from '../pages/Deals';

export const routes: Array<IRoute> = [
  {
    path: '/cars',
    component: Cars,
    title: 'Search',
    enabled: true,
    icon: CarRental,
    key: 'cars',
    menu: false,
    protected: false,
  },
  {
    path: '/deals',
    component: Deals,
    title: 'My Deals',
    enabled: true,
    icon: Handshake,
    key: 'deals',
    menu: true,
    protected: true,
  },
  {
    path: '/deals/:id',
    component: Deal,
    title: 'Deal',
    enabled: true,
    protected: true,
    icon: Handshake,
    key: 'deal',
    menu: false,
  },
];
